
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { LocalizedStrict } from '../../../../localization/components/AppLocalized'
import { useState } from 'react';
import { Box } from '@mui/system';
import { makeStyles } from "tss-react/mui"



type SelectSurveyProps = Readonly<{
    className?: string
}>



const useStyles = makeStyles()((_theme) => ({
    box: {
        width: "20rem", marginBottom: "2rem"
    }
}))

export function SelectSurvey({ className }: SelectSurveyProps) {
    const { classes, cx } = useStyles()



    const [question, setQuestion] = useState<string>("Hvordan var maden?")

    const handleChange = (event: SelectChangeEvent) => {
        setQuestion(event.target.value as string);
    };

    return (
        <Box className={cx(className, classes.box)}>
            <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Survey</InputLabel>
                <Select
                    value={question}
                    label="Survey"
                    onChange={handleChange}
                >
                    <MenuItem value="10">Ten</MenuItem>
                    <MenuItem value="20">Twenty</MenuItem>
                    <MenuItem value="30">Thirty</MenuItem>
                </Select>
            </FormControl>
        </Box >
    );
}
